import { ActionTypes }   from '../actions/types';
import { dataStateType } from 'reducer/types';


export const initialDataState: dataStateType = {
  userInfo:           { userLogedIn: '', userName: '', userEmail: '', userId: '', userRole: '', semelMosad: '', gradeAccess: [], plus: false, subscriptionExpired: false, subscriptionExpiresAt: '', userFoundInTables: [], userExists: -1, session: '', permissionResolved: false },
  dataState:          { userActivity: [], totalLikes: [], scores: [] },
  dataUpdateState:    { content: false, teacherContent: false, activity: false, totalLikes: false, scores: false, final: false },
  storageUpdateState: false,
  encodedInfo:        { userId: '', timeLimit: '' },
  modalVariant:       '',
  createDataOnce:     false
};

const dataReducer = (state = initialDataState, action: ActionTypes) => {

  switch (action.type) {


//SET_USER_INFO   -      -      -      -      -      -      -      -      -      -      -      -

    case 'SET_USER_INFO':
      {

        const { userName, userEmail, userId, userRole, semelMosad, userLogedIn, gradeAccess, plus, subscriptionExpired, subscriptionExpiresAt, userFoundInTables, userExists, session, permissionResolved = false } = action.payload;
        return {
          ...state,
          userInfo: {
            userLogedIn:           userLogedIn,
            userName:              userName,
            userEmail:             userEmail,
            userId:                userId,
            userRole:              userRole,
            semelMosad:            semelMosad,
            gradeAccess:           gradeAccess,
            plus:                  plus,
            subscriptionExpired:   subscriptionExpired,
            subscriptionExpiresAt: subscriptionExpiresAt,
            userFoundInTables:     userFoundInTables,
            userExists:            permissionResolved ? (userExists ? 1 : 0) : -1,
            session:               session,
            permissionResolved:    permissionResolved
          }
        }

      }





case 'SET_CREATE_DATA_ONCE':
  {  
    return {
      ...state,
      createDataOnce: true
    }
}



case 'SET_CONTENT':

  {
    const { contentUpdated, teacherContentUpdated } = action.payload;

    return {
      ...state,
      dataUpdateState: {
        ...state.dataUpdateState,
        content:        !!contentUpdated        ? contentUpdated        : state.dataUpdateState.content,
        teacherContent: !!teacherContentUpdated ? teacherContentUpdated : state.dataUpdateState.teacherContent
      }
    }

  }




case 'SET_USER_ACTIVITY':
  {

    return {
      ...state,
      dataState: { 
        ...state.dataState,
        userActivity: action.payload 
      }
    }

  }

case 'UPDATE_ACTIVITY': {

  return {
     ...state,
     dataUpdateState: {
       ...state.dataUpdateState,
       activity: true
     }
  }

}

//_ _ _ _

case 'SET_TOTAL_LIKES':
  {

    return {
      ...state,
      dataState: { 
        ...state.dataState,
        totalLikes: action.payload 
      }
    }

  }

case 'UPDATE_TOTAL_LIKES': {

  return {
     ...state,
     dataUpdateState: {
       ...state.dataUpdateState,
       totalLikes: true
     }
  }

}

//_ _ _ _


case 'SET_STUDENT_SCORES':
  {

    return {
      ...state,
      dataState: { 
        ...state.dataState,
        scores: action.payload 
      }
    }

  }

case 'UPDATE_STUDENT_SCORES': {

  return {
     ...state,
     dataUpdateState: {
       ...state.dataUpdateState,
       scores: action.payload
     }
  }

}
//


case 'UPDATE_GUEST_DATA': {

  return {
     ...state,
     dataUpdateState: { 
       content:    true, 
       activity:   true, 
       totalLikes: true, 
       scores:     true, 
       final:      false 
    // final:      true, 

    }
  }

}






// SET_DATA    -      -      -      -      -      -      -      -      -      -      -      -

 

case 'SET_DATA': {

  const { variant } = action.payload;

  // data found in DB

  if ( process.env.NODE_ENV === 'development' ) {
    return {
      ...state,
      dataUpdateState: {
        ...state.dataUpdateState,
        final: true
      }
    }
  }
  else {
    if (variant === 'stored') {

      return {
        ...state,
        storageUpdateState: true
      }
    }
    if (variant === 'real') { 
  
      return {
        ...state,
        dataUpdateState: {
          ...state.dataUpdateState,
          final: true
        },
        storageUpdateState: true
      }
    }
  }
  
  

  // data found in local storage

  return {
    ...state,
    storageUpdateState: true
  }
 
  

} 



case 'CHANGE_MODAL_STATE':
  {

    const modalVariant = action.payload;

    return {
      ...state,
      modalVariant: modalVariant
    }
  }


//CHANGE_MODAL_STATE   -      -      -      -      -      -      -      -      -      -      -      -


  case 'CREATE_ERROR': {

    return {
      ...state,
      modalVariant: 'generalError'
    }
  
  }
  
  

//SET_SHOW_EMAIL_MODAL   -      -      -      -      -      -      -      -      -      -      -      -






//SET_ENCODED_INFO   -      -      -      -      -      -      -      -      -      -      -      -


case 'SET_ENCODED_INFO':
  {

    return {
      ...state,
      encodedInfo: action.payload
    }

  }


// -      -      -      -      -      -      -      -      -      -      -      -




    default: return state;
  }
};

export type reducerType = ReturnType<typeof dataReducer>;

export { dataReducer };
